import { Chip, Tooltip, Typography } from '@mui/material'
import moment from 'moment'
import { IPartnerClientIso14001 } from '../../../shared/services/partner/partner.model'

const formatDate = (isoDate: string): string => moment(isoDate, 'YYYY-MM-DD').format('DD/MM/YYYY')

// Ink chip styling: the readiness palette's "work to do" colour, used where red would read as a
// failure (an expired certificate).
const INK_CHIP_SX = { borderColor: 'text.primary', color: 'text.primary' }

export const PARTNER_ISO14001_STATE_LABELS: Record<IPartnerClientIso14001['state'], string> = {
  none: 'None recorded',
  current: 'Current',
  expiring_soon: 'Expires soon',
  transition_due: 'Transition due',
  expired: 'Expired',
}

/** One client's ISO 14001 status as the partner sees it: the Clients page column and the drill-in header. */
export const PartnerIso14001Chip = ({ iso14001 }: { iso14001: IPartnerClientIso14001 | null | undefined }) => {
  if (!iso14001 || iso14001.state === 'none') {
    return <Typography variant='body2' sx={{ color: 'text.secondary' }}>None recorded</Typography>
  }
  const label = iso14001.label || 'ISO 14001'
  switch (iso14001.state) {
    case 'transition_due':
      return (
        <Tooltip title='A 2015-edition certificate that must move to the 2026 edition by the end of the transition. Indicative date: confirm it with the certification body.' placement='top'>
          <Chip size='small' color='warning' variant='outlined' label={`${label}: move to 2026${iso14001.effectiveExpiresOn ? ` by ${formatDate(iso14001.effectiveExpiresOn)}` : ''}`} />
        </Tooltip>
      )
    case 'expiring_soon':
      return <Chip size='small' color='warning' variant='outlined' label={`${label}: expires${iso14001.effectiveExpiresOn ? ` ${formatDate(iso14001.effectiveExpiresOn)}` : ' soon'}`} />
    case 'expired':
      return <Chip size='small' variant='outlined' sx={INK_CHIP_SX} label={`${label}: expired`} />
    default:
      return <Chip size='small' color='primary' label={`${label}: current`} />
  }
}
